import axios from 'axios';

export const optionApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/options`,
    headers: {
        'Content-Type': 'application/json'
    }
})